/**
 * Checks if an email is a synthetic/placeholder email (not a real user email).
 * These are auto-generated for phone-only signups and should never be displayed or emailed.
 */
export const isSyntheticEmail = (email: string | null | undefined): boolean => {
  if (!email) return true;
  return email.endsWith('@paudhify.local');
};

/**
 * Returns the email if it's real, or a fallback string if synthetic/missing.
 */
export const displayEmail = (email: string | null | undefined, fallback = ''): string => {
  if (!email || isSyntheticEmail(email)) return fallback;
  return email;
};
